import {
  upsellArrayHasDisplayableCharts,
  upsellArrayHasHype,
} from '~/helpers/ProductUpsell'

import type { UpsellStatusDescriptor } from '~/types/Product'

export function useTrackUpsells(
  trackUpsells: MaybeRefOrGetter<UpsellStatusDescriptor[]>,
) {
  const hasChartsUpsell = computed(() =>
    upsellArrayHasDisplayableCharts(toValue(trackUpsells)),
  )
  const hasHypeUpsell = computed(() =>
    upsellArrayHasHype(toValue(trackUpsells)),
  )

  return {
    hasChartsUpsell,
    hasHypeUpsell,
  }
}
